export default {
	"areafuncional": {
		"1": "Marketing",
		"2": "Ventas",
		"3": "Marketing Digital",
		"4": "Contabilidad y Finanzas",
		"5": "Recursos Humanos",
		"6": "Logística",
		"7": "Otras",
		"8": "Comunicación",
		"9": "Administración y Servicios Generales",
		"10": "Tecnología y Digital Business",
		"11": "Operaciones",
		"12": "Consultoría"
	},
	"idioma": {
		"11": "Español",
		"8": "Catalan",
		"10": "Gallego",
		"9": "Euskera",
		"1": "Inglés",
		"5": "Alemán",
		"6": "Chino",
		"2": "Francés",
		"12": "Indi",
		"3": "Italiano",
		"13": "Japonés",
		"4": "Portugués",
		"14": "Ruso",
		"15": "Albanés",
		"16": "Armenio",
		"17": "Azerí",
		"18": "Bielorruso",
		"19": "Bosnio",
		"20": "Bretón",
		"21": "Búlgaro",
		"22": "Checo",
		"23": "Croata",
		"24": "Danés",
		"25": "Eslovaco",
		"26": "Esloveno",
		"27": "Estonio",
		"28": "Finés",
		"29": "Galés",
		"30": "Georgiano",
		"31": "Griego",
		"32": "Húngaro",
		"33": "Irlandés",
		"34": "Islandés",
		"35": "Letón",
		"36": "Lituano",
		"37": "Luxemburgués",
		"38": "Macedonio",
		"39": "Maltés",
		"40": "Montenegrino",
		"41": "Neerlandés",
		"42": "Noruego",
		"43": "Polaco",
		"44": "Romanche",
		"45": "Rumano",
		"46": "Serbio",
		"47": "Sueco",
		"48": "Turco",
		"49": "Ucraniano",
		"7": "Otros"
	},
	"nivelidioma": {
		"1": "A1",
		"2": "A2",
		"3": "B1",
		"4": "B2",
		"5": "C1",
		"6": "C2",
		"7": "Nativo"
	},
	"discapacidad": {
		"1": "Baja",
		"2": "Media",
		"3": "Alta"
	},
	"experiencia": {
		"1": "Sin experiencia",
		"2": "Entre 1 y 2 años",
		"3": "Entre 2 y 3 años",
		"4": "Entre 3 y 5 años",
		"5": "Entre 5 y 10 años",
		"6": "Más de 10 años"
	},
	"estados": {
		"2": "Inscrito",
		"4": "Desestimado",
		"5": "Cerrado",
		"6": "Seleccionado",
		"8": "En proceso",
		"9": "Entrevistado"
	},
	"sectores": {
		"1": "Gran Consumo",
		"2": "Tecnología",
		"3": "Banca y Servicios Financieros",
		"5": "Consultoría de Negocio",
		"7": "Venta y Distribución",
		"8": "Industria",
		"9": "Industria Farmacéutica y Biotecnológica",
		"10": "Medios de Comunicación y Difusión",
		"11": "Otros Servicios",
		"12": "Automoción",
		"14": "Arquitectura, Ingeniería y Construcción",
		"16": "Consultoría de RR.HH. y Headhunting",
		"17": "Industria Energética",
		"18": "Educación",
		"19": "Administración Pública",
		"20": "Asociaciones y Fundaciones",
		"21": "Entretenimiento, Cultura y Deporte",
		"22": "Agencias de Marketing y Comunicación",
		"23": "Telecomunicaciones",
		"24": "Videojuegos",
		"25": "Inmobiliaria",
		"26": "Alimentación y Bebidas",
		"27": "Seguros",
		"28": "Atención Sanitaria",
		"29": "Turismo",
		"30": "Hostelería y Restauración",
		"31": "Moda, Lujo y Cosmética",
		"32": "Almacenamiento, Transporte y Logística",
		"33": "Sector Primario"
	},
	"contratos": {
		"1": "Contrato laboral",
		"2": "Contrato temporal",
		"3": "Contrato laboral en prácticas",
		"4": "Autónomo o mercantil"
	},
	"salario": {
		"1": "12.000€ - 20.000€",
		"2": "21.000€ - 27.000€",
		"3": "28.000€ - 39.000€",
		"4": "40.000€ - 60.000€",
		"5": "60.000€ - 80.000€",
		"6": "80.000€ - 120.000€",
		"7": "120.000€ - 150.000€",
		"8": "+ de 150.000€"
	},
	"tipoDoc": {
		"1": "CV",
		"2": "Permiso de trabajo para la UE",
		"3": "Carta de presentación",
		"4": "Carta de recomendación",
		"5": "Portfolio",
		"6": "Copia DNI",
		"7": "Copia tarjeta Seguridad Social",
		"8": "Expediente académico oficial",
		"10": "Otro",
		"14": "CV en inglés"
	},
	"tipodocsubida": {
		"1": "CV",
		"14": "CV en inglés",
		"3": "Carta de presentación",
		"4": "Carta de recomendación",
		"5": "Portfolio",
		"10": "Otro"
	},
	"sedes": {
		"1": "Madrid",
		"2": "Sevilla",
		"3": "Valencia",
		"4": "Navarra",
		"5": "Bilbao",
		"6": "Barcelona",
		"7": "Málaga",
		"8": "Granada",
		"9": "Zaragoza",
		"10": "Vigo",
		"12": "Tudela"
	},
	"nivelEstudios": {
		"1": "Grado",
		"2": "Máster",
		"3": "Doctorado",
		"4": "Doble Grado",
		"5": "Doble Máster",
		"6": "Formación Profesional",
		"7": "Cursos"
	},
	"ambitoEstudios": {
		"1": "Educación",
		"2": "Artes y humanidades",
		"3": "Ciencias sociales y derecho",
		"4": "Ciencias e informática",
		"5": "Ingeniería, industria y construcción",
		"6": "Agricultura y veterinaria",
		"7": "Salud y servicios sociales",
		"8": "Servicios"
	},
	"especialidadEstudios": {
		"1_1": "Formación de docentes de enseñanza infantil",
		"1_2": "Formación de docentes de enseñanza primaria",
		"1_3": "Otra Formación de personal docente y ciencias de la educación",
		"1_4": "Otra Educación",
		"2_5": "Técnicas audiovisuales",
		"2_6": "Artes",
		"2_7": "Lenguas",
		"2_8": "Humanidades",
		"2_9": "Otras Artes y Humanidades",
		"3_10": "Psicología",
		"3_11": "Economía",
		"3_12": "Otras Ciencias sociales y del comportamiento",
		"3_13": "Periodismo e información",
		"3_14": "Administración y gestión de empresas",
		"3_15": "Otra Educación comercial y empresarial",
		"3_16": "Derecho",
		"3_17": "Otras Ciencias sociales, educación comercial y derecho",
		"4_18": "Ciencias de la vida: Biología, Ambientales",
		"4_19": "Ciencias Físicas, químicas, geológicas",
		"4_20": "Matemáticas y Estadística",
		"4_21": "Otras Ciencias",
		"4_22": "Informática",
		"5_23": "Ingenierías",
		"5_24": "Arquitectura y construcción",
		"6_25": "Agricultura, ganadería y pesca",
		"6_26": "Veterinaria",
		"6_27": "Otras Agricultura y veterinaria",
		"7_28": "Medicina",
		"7_29": "Enfermería y atención a enfermos",
		"7_30": "Otras ciencias de la Salud (Farmacia, Odontología, Fisioterapia..)",
		"7_31": "Trabajo social y orientación",
		"7_32": "Otras Salud y servicios sociales",
		"8_33": "Otros Servicios",
		"8_34": "Actividad Física y del Deporte",
		"8_35": "Turismo y Hostelería"
	},
	"paises": {
		"5": "Afganistán",
		"465": "África del Sur",
		"482": "Alaska",
		"11": "Albania",
		"107": "Alemania",
		"2": "Andorra",
		"17": "Angola",
		"9": "Anguila",
		"19": "Antártida",
		"7": "Antigua y Barbuda",
		"15": "Antillas Neerlandesas",
		"367": "Arabia Saudí",
		"117": "Argelia",
		"21": "Argentina",
		"13": "Armenia",
		"29": "Aruba",
		"27": "Australia",
		"25": "Austria",
		"473": "Azerbaiján",
		"57": "Bahamas",
		"41": "Bahrein",
		"33": "Bangladesh",
		"31": "Barbados",
		"35": "Bélgica",
		"69": "Belice",
		"45": "Benin",
		"49": "Bermudas",
		"53": "Bolivia",
		"487": "Borneo",
		"472": "Bosnia-Herzegovina",
		"65": "Botswana",
		"63": "Boubet (Isla)",
		"55": "Brasil",
		"51": "Brunei Darussalam",
		"39": "Bulgaria",
		"37": "Burkina Faso",
		"61": "Burma",
		"43": "Burundi",
		"59": "Bután",
		"67": "Byellorussian SSR",
		"99": "Cabo Verde",
		"235": "Caimanes (Islas)",
		"474": "Camboya",
		"87": "Camerún",
		"71": "Canadá",
		"95": "Canton and Enderbury Islands",
		"405": "Chad",
		"85": "Chile",
		"89": "China",
		"103": "Chipre",
		"101": "Christmas (Isla)",
		"73": "Cocos, Keeling (Islas)",
		"91": "Colombia",
		"225": "Comores",
		"83": "Cook (Islas)",
		"229": "Corea (República P. Democrática)",
		"231": "Corea (República)",
		"81": "Costa de Marfil",
		"93": "Costa Rica",
		"475": "Croacia",
		"97": "Cuba",
		"111": "Dinamarca",
		"109": "Djibuti",
		"113": "Dominica",
		"115": "Dominicana (República)",
		"119": "Ecuador",
		"123": "Egipto",
		"397": "El Salvador",
		"3": "Emiratos Árabes Unidos",
		"127": "Eritrea",
		"492": "Escocia",
		"1": "España",
		"439": "Estado de la Ciudad del Vaticano",
		"435": "Estados Unidos",
		"121": "Estonia",
		"131": "Etiopía",
		"137": "Falkland o Malvinas (Islas)",
		"135": "Fidji",
		"335": "Filipinas",
		"133": "Finlandia",
		"143": "Francia",
		"145": "Gabón",
		"163": "Gambia",
		"151": "Georgia",
		"157": "Ghana",
		"159": "Gibraltar",
		"149": "Granada",
		"171": "Grecia",
		"161": "Groenlandia",
		"167": "Guadalupe",
		"175": "Guam",
		"173": "Guatemala",
		"179": "Guayana",
		"153": "Guayana Francesa",
		"155": "Guernsey and Jersey",
		"165": "Guinea",
		"177": "Guinea Bissau",
		"169": "Guinea Ecuatorial",
		"187": "Haití",
		"183": "Heard y McDonald (Islas)",
		"478": "Holanda",
		"185": "Honduras",
		"181": "Hong Kong",
		"189": "Hungría",
		"483": "India",
		"191": "Indonesia",
		"199": "Internacional",
		"205": "Irán",
		"203": "Iraq",
		"193": "Irlanda",
		"197": "Isla de Man",
		"207": "Islandia",
		"141": "Islas Feroe",
		"267": "Islas Marshall",
		"445": "Islas Vírgenes Británicas",
		"195": "Israel",
		"209": "Italia",
		"211": "Jamaica",
		"215": "Japón",
		"488": "Java",
		"217": "Johnston Island",
		"213": "Jordania",
		"221": "Kampuchea",
		"237": "Kazajistan",
		"219": "Kenia",
		"223": "Kiribati",
		"233": "Kuwait",
		"239": "Laos (República Dem. Popular)",
		"251": "Lesotho",
		"484": "Letonia",
		"241": "Líbano",
		"249": "Liberia",
		"257": "Libia (Jamahiriya Árabe)",
		"245": "Liechtenstein",
		"253": "Lituania",
		"255": "Luxemburgo",
		"275": "Macao",
		"490": "Macedonia",
		"265": "Madagascar",
		"293": "Malasia",
		"289": "Malawi",
		"287": "Maldivas (Islas)",
		"271": "Malí",
		"283": "Malta",
		"259": "Marruecos",
		"277": "Martinica",
		"285": "Mauricio",
		"279": "Mauritania",
		"291": "Méjico",
		"139": "Micronesia",
		"269": "Midway Islands",
		"263": "Moldavia",
		"261": "Mónaco",
		"273": "Mongolia",
		"281": "Montserrat",
		"295": "Mozambique",
		"491": "Myanmar",
		"297": "Namibia",
		"315": "Nauru",
		"313": "Nepal",
		"317": "Neutral Zone",
		"307": "Nicaragua",
		"301": "Níger",
		"305": "Nigeria",
		"319": "Niue",
		"303": "Norfolk (Isla)",
		"311": "Noruega",
		"299": "Nueva Caledonia y Dependencias",
		"321": "Nueva Zelanda",
		"201": "Océano Índico (Territorio Británico)",
		"323": "Omán",
		"327": "Pacific Islands",
		"309": "Países Bajos",
		"337": "Pakistán",
		"351": "Palau",
		"325": "Panamá",
		"333": "Papúa-Nueva Guinea",
		"353": "Paraguay",
		"329": "Perú",
		"343": "Pitcairn",
		"331": "Polinesia Francesa",
		"339": "Polonia",
		"347": "Portugal",
		"345": "Puerto Rico",
		"355": "Qatar",
		"147": "Reino Unido",
		"77": "Republic of the Congo",
		"75": "República Centroafricana",
		"105": "República Checa",
		"477": "República Cooperativa de Guyana",
		"476": "República de Eslovenia",
		"480": "República Dem. Congo",
		"383": "República Eslovaca",
		"481": "República Pop. Congo",
		"479": "República Sudafricana",
		"357": "Reunion",
		"365": "Ruanda",
		"359": "Rumania",
		"363": "Russia",
		"125": "Sáhara Occidental",
		"47": "Saint Barthélemy",
		"227": "Saint Kitts and Nevis",
		"369": "Salomón (Islas)",
		"457": "Samoa",
		"23": "Samoa Americana",
		"387": "San Marino",
		"341": "San Pedro y Miquelon",
		"441": "San Vicente y Granadinas",
		"379": "Santa Helena",
		"243": "Santa Lucía",
		"395": "Santo Tomás y Príncipe",
		"389": "Senegal",
		"361": "Serbia y Montenegro",
		"371": "Seychelles",
		"385": "Sierra Leona",
		"377": "Singapur",
		"399": "Siria (República Árabe)",
		"391": "Somalia",
		"247": "Sri Lanka",
		"373": "Sudan",
		"375": "Suecia",
		"79": "Suiza",
		"489": "Sumatra",
		"393": "Surinam",
		"381": "Svalbard e Isla Juan Mayen",
		"401": "Swazilandia",
		"411": "Tailandia",
		"427": "Taiwan",
		"429": "Tanzania",
		"407": "Tierras Australes Francesas",
		"419": "Timor Oriental",
		"409": "Togo",
		"413": "Tokelau",
		"417": "Tonga",
		"423": "Trinidad y Tobago",
		"415": "Túnez",
		"485": "Turkmenistán",
		"403": "Turks y Caicos (Islas)",
		"421": "Turquía",
		"425": "Tuvalu",
		"431": "Ucrania",
		"433": "Uganda",
		"437": "Uruguay",
		"349": "US Misc Pacific Islands",
		"486": "Uzbekistán",
		"451": "Vanuatu",
		"443": "Venezuela",
		"449": "Vietnam",
		"447": "Vírgenes de E.E.U.U. (Islas)",
		"455": "Wake Islands",
		"453": "Wallis y Futuna (Islas)",
		"461": "Yemen",
		"459": "Yemen, Democratic",
		"463": "Yugoslavia",
		"469": "Zaire",
		"467": "Zambia",
		"471": "Zimbabwe",
	},
	"provincias": {
		"1": "Álava / Araba",
		"2": "Albacete",
		"3": "Alicante / Alacant",
		"4": "Almería",
		"33": "Asturias",
		"5": "Ávila",
		"6": "Badajoz",
		"8": "Barcelona",
		"9": "Burgos",
		"10": "Cáceres",
		"11": "Cádiz",
		"39": "Cantabria",
		"12": "Castellón / Castelló",
		"51": "Ceuta",
		"13": "Ciudad Real",
		"14": "Córdoba",
		"16": "Cuenca",
		"17": "Gerona / Girona",
		"18": "Granada",
		"19": "Guadalajara",
		"20": "Guipúzcoa / Gipuzkoa",
		"21": "Huelva",
		"22": "Huesca",
		"7": "Islas Baleares",
		"23": "Jaén",
		"15": "La Coruña / A Coruña",
		"26": "La Rioja",
		"35": "Las Palmas",
		"24": "León",
		"25": "Lérida / Lleida",
		"27": "Lugo",
		"28": "Madrid",
		"29": "Málaga",
		"52": "Melilla",
		"30": "Murcia",
		"31": "Navarra / Nafarroa",
		"32": "Orense / Ourense",
		"34": "Palencia",
		"36": "Pontevedra",
		"38": "S.C.Tenerife",
		"37": "Salamanca",
		"40": "Segovia",
		"41": "Sevilla",
		"42": "Soria",
		"43": "Tarragona",
		"44": "Teruel",
		"45": "Toledo",
		"46": "Valencia/valència",
		"47": "Valladolid",
		"48": "Vizcaya / Bizkaia",
		"49": "Zamora",
		"50": "Zaragoza",
	}
}


// WEBPACK FOOTER //
// ./src/dominios/index.js